import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Roles } from '@shared/models/types';
import { ProfileService } from '@shared/services/api/profile.service';
import { ModalService } from '@shared/services/modal.service';
import { take, tap } from 'rxjs';
import { ModalPersonalDataInfoComponent } from 'src/app/register/modal-personal-data-info/modal-personal-data-info.component';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent implements OnInit {
  private _modalService = inject(ModalService);
  private _profileService = inject(ProfileService);
  private _router = inject(Router);

  ngOnInit() {
    this._profileService.profile$
      .pipe(
        take(1),
        tap((profile) => {
          if (!profile.termsAndConditions) {
            this._modalService.open(
              ModalPersonalDataInfoComponent,
              { showBtns: true, showClose: false },
              {
                backdrop: 'static',
                keyboard: false,
                size: 'lg'
              }
            );
          } else {
            if (profile.role === Roles.PARTNER) {
              this._router.navigate(['/final-users']);
            } else {
              this._router.navigate(['/home']);
            }
          }
        })
      )
      .subscribe();
  }
}
